import { Component } from '../Component'
import { inject } from '../../services/di'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'
import { LocationService } from '../../services/LocationService'
import { Link } from '../flipp-link/Link'
import { CategoryService } from '../../services/CategoryService'
import { BannerService } from '../../services/BannerService'

@element('giveaway-banner')
export class GiveawayBanner extends Component<any, any> {
    @inject location: LocationService
    @inject categoryService: CategoryService
    @inject bannerService: BannerService

    render() {
        const isFrench = this.location.locale === 'fr-ca'
        const textClassAppendix = isFrench ? ' french' : ''
        return (
            <div class="giveaway-banner">
                <div class={`giveaway-banner__title ${textClassAppendix}`}>
                    {i18n('giveaway_banner_title')}
                </div>
                <div class="giveaway-banner__date">
                    {i18n('giveaway_banner_date')}
                </div>
                <div class="giveaway-banner__subtitle">
                    {i18n('giveaway_banner_subtitle')}
                </div>
                <a
                    href={this.bannerService.getGiveawayLink()}
                    target="_blank"
                    class="giveaway-banner__button"
                    id="giveaway-banner__button"
                >
                    {i18n('giveaway_banner_button_text')}
                </a>
            </div>
        )
    }

    renderButton() {
        const textClassAppendix =
            this.location.locale === 'fr-ca' ? ' french' : ''
        const textClass = 'flipp-button' + textClassAppendix
        return (
            <Link class={textClass} to="proudlyCanadian">
                {i18n('proudly_canadian_deals')}
            </Link>
        )
    }
}
